import Vue from 'vue';
import axios from 'axios';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import * as appApi from '@/api/app.js';
import mediaTypesApi from '@/api/artist/media-types';

import * as artistCategoriesApi from '@/api/artist/categories.js';
import * as releasesApi from '@/api/artist/releases.js'; // @toDo remove when API will be ready
import * as collectionsApi from '@/api/artist/collections';
import * as elementsApi from '../../../api/artist/elements';
import * as templatesApi from '../../../api/artist/templates-edit';


// import * as categoriesApi from '../../../api/categories';
import musicalKeys from './mock/musicalKey.json';

function refreshCancelToken(state, tokenName) {
  // cancel previous request
  if (_.has(state.cancelTokens, tokenName)) {
    const info = {
      type: 'cancelToken',
      name: `${tokenName}`,
    };
    state.cancelTokens[tokenName].cancel(info);
  }

  // create cancel token
  state.cancelTokens[tokenName] = axios.CancelToken.source();

  return state.cancelTokens[tokenName];
}

Vue.prototype.$hasOwnProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

const state = {
  loading: false,
  saved: false,
  sidebarStatus: false,
  element: null,
  elementForm: {},
  // collection: null,
  // collectionForm: null,
  tabs: {
    basic: {
      validators: [],
    },
    optional: {
      validators: [],
    },
  },
  taxonomy: {
    categories: null,
    styles: null,
    moods: null,
    genres: null,
    types: null,
  },
  priceTemplates: null,
  collections: [],
  softwares: [],
  instruments: [],
  musicalKeys,
  countries: [],
  // metadataTemplates: null,

  // model / property releases
  releaseFiles: null,
  modelReleases: [],
  propertyReleases: [],

  // music edit types
  // not used
  editTypes: null,

  cancelTokens: {},
};

const getters = {
  element: ({ element }) => element,
  elementForm: ({ elementForm }) => elementForm,
  // collection: ({ collection }) => collection,
  // collectionForm: ({ collectionForm }) => collectionForm,
  sidebarStatus: ({ sidebarStatus }) => sidebarStatus,
  mediaType: ({ element }) => _.get(element, 'mediaType'),
  masterVariant: ({ element }) => _.get(element, 'variants', []).find(x => x.master === true),
  // @deprecate
  // file: ({ element }) => (_.get(element, 'variants', []).length ? element.variants[0].file : null),
  requiredVersions: ({ element }) => _.get(element, 'mediaTypeDetails.softwareRequired'),
  //
  getElementKey: ({ element }) => key => element[key],
  //
  isVideo: ({ element }) => isProductType('video', _.get(element, 'mediaType')),
  // tabs Errors
  getTabError: state => tabName => (state.tabs[tabName].validators.find(x => x.v.$error !== false)),
  getReleaseFiles: state => type => (Array.isArray(state.releaseFiles) ? state.releaseFiles.filter(x => x.type === type) : []),
  //
  thumbnails(state) {
    return _.get(state.element, 'thumbnails.jpgs', []);
  },
  autoGeneratedThumbnails(state) {
    return _.get(state.element, 'thumbnails.jpgs', []).filter(thumb => _.get(thumb, 'autoGenerated'));
  },
};

const mutations = {
  setSaved(state, status) {
    state.saved = status;
  },
  addElementFormField({ elementForm }, { field, value }) {
    Vue.set(elementForm, field, value);
    console.log('elementForm', elementForm);
  },
  removeElementFormField({ elementForm }, field) {
    delete elementForm[field];
  },
  addElementVariantFormField({ element, elementForm }, { sku, field, value }) {
    const variant = element.variants.find(x => x.id === sku);
    if (!variant) {
      // invalid variant
      return;
    }
    variant[field] = value;
    const formVariants = _.get(elementForm, 'variants') || {};
    _.set(formVariants, [sku, field], value);
    Vue.set(elementForm, 'variants', formVariants);
  },
  setElement(state, payload) {
    state.element = payload;
  },
  setElementKey({ element }, { key, value }) {
    Vue.set(element, key, value);
  },
  setElementField(state, { field, value }) {
    _.set(state.element, field, value);
  },
  setElementVariants(state, variants) {
    Vue.set(state.element, 'variants', variants);
    // state.element.variants = variants;
  },
  removeElementVariant(state, index) {
    if (index > -1) state.element.variants.splice(index, 1);
  },
  setDefaultElementVariant(state, index) {
    if (index > -1) {
      state.element.variants.forEach(v => {
        v.master = false;
      });
      state.element.variants[index].master = true;
    }
  },
  setLoadingElementVariant(state, { index, status }) {
    if (index > -1) state.element.variants[index].loading = status;
  },
  setVariantField({ element }, { sku, field, value }) {
    const variant = element.variants.find(x => x.id === sku);
    if (variant) {
      variant[field] = value;
      // element.variants[sku][field] = value;
    }
  },
  setLoading(state, status) {
    state.loading = status;
  },
  // SIDEBAR
  setSidebar(state, status) {
    state.sidebarStatus = status;
  },
  toggleSidebar(state) {
    state.sidebarStatus = !state.sidebarStatus;
  },
  // BASIC
  setPriceTemplates(state, payload) {
    state.priceTemplates = payload;
  },
  setCollections(state, collections) {
    state.collections = collections;
  },
  // taxonomy
  setCategories(state, payload) {
    state.taxonomy.categories = payload;
  },
  setMoods(state, payload) {
    state.taxonomy.moods = payload;
  },
  setGenres(state, payload) {
    state.taxonomy.genres = payload;
  },
  setTypes(state, payload) {
    state.taxonomy.types = payload;
  },
  setInstruments(state, instruments) {
    state.instruments = instruments;
  },
  setEditTypes(state, editTypes) {
    state.editTypes = editTypes;
  },
  //
  setThumb({ element }, thumb) {
    element.thumbnails.jpg = thumb;
  },
  setVideoPreview({ element }, { ext, url }) {
    element.previews[ext] = url ? { url } : false;
  },
  addCategory({ element: { categories } }, category) {
    const index = categories.findIndex(item => item.id === category.id);
    if (index === -1) {
      categories.push(category);
    }
  },
  toggleCategory({ element: { categories } }, category) {
    const index = categories.findIndex(item => item.id === category.id);
    if (index > -1) {
      categories.splice(index, 1);
    } else {
      categories.push(category);
    }
  },
  removeCategory({ element: { categories } }, category) {
    const index = categories.findIndex(x => x.id === category.id);
    if (index > -1) {
      categories.splice(index, 1);
    }
    // categories.splice(index, 1);
  },
  // OPTIONAL
  addKeyword({ element: { keywords } }, keyword) {
    keywords.push(keyword);
  },
  removeKeyword({ element: { keywords } }, keyword) {
    const index = keywords.indexOf(keyword);
    keywords.splice(index, 1);
  },
  setStyles(state, payload) {
    state.taxonomy.styles = payload;
  },
  setElementFormField({ elementForm }, { field, key, value }) {
    if (Vue.prototype.$hasOwnProp(elementForm, field)) {
      console.log('hasownprop', field, value);
      elementForm[field][key] = value;
    } else {
      Vue.set(elementForm, field, { [key]: value });
    }
  },
  updateElementForm({ elementForm }, { field, value }) {
    elementForm[field] = value;
  },
  // tabs Errors
  updateTabValidators({ tabs }, {
    tab,
    name,
    v,
    id,
  }) {
    const validator = tabs[tab].validators.find(x => x.name === name);
    if (validator) {
      validator.v = v;
    } else {
      tabs[tab].validators.push({ name, v, id });
    }
    // _.set(tabs[tab], ['validators', name], v);
  },
  removeTabValidator({ tabs }, { tab, id }) {
    const index = tabs[tab].validators.findIndex(item => item.id === id);
    if (index > -1) tabs[tab].validators.splice(index, 1);
  },
  setReleaseFiles(state, payload) {
    state.releaseFiles = payload;
  },
  pushToModelReleases(state, modelRelease) {
    state.modelReleases.unshift(modelRelease);
  },
  pushToPropertyReleases(state, propertyRelease) {
    state.propertyReleases.unshift(propertyRelease);
  },
  setModelReleases(state, modelReleases) {
    state.modelReleases = [...state.modelReleases, ...modelReleases];
  },
  setPropertyReleases(state, propertyReleases) {
    state.propertyReleases = [...state.propertyReleases, ...propertyReleases];
  },
  setSoftwares(state, softwares) {
    state.softwares = softwares;
  },
  setCountries(state, countries) {
    state.countries = countries;
  },
  reset(state) {
    console.log('reset ArtistElementEdit');
    state.saved = false;
    state.elementForm = {};
    state.element = null;
    // state.collectionForm = {};
    // state.collection = null;
    state.tabs.basic.validators = [];
    state.tabs.optional.validators = [];
  },
  resetElementForm(state) {
    state.elementForm = {};
  },
  addThumbnails(state, thumbnails) {
    state.element.thumbnails.jpgs = [...thumbnails, ...state.element.thumbnails.jpgs];
  },
  setPreview(state, preview) {
    state.element.previews.jpg = preview;
  },
};

const actions = {
  setElementFormField({ commit }, { field, value }) {
    // commit('setElementKey', {
    //   key: field,
    //   value: value,
    // });

    switch (field) {
      // map taxonomy ids
      case 'categories':
      // case 'genres':
      // case 'moods':
      // case 'styles':
      // case 'types':
        value = value.map(item => item.id);
        break;
        // case 'variants':
        //   value = this.variantsFormField(value);
        //   break;
      default:
        break;
    }
    console.log(`UPDATE FORM_FIELD ${field}: ${value}`);
    commit('addElementFormField', { field, value });
  },
  setElementVariantFormField({ commit }, { sku, field, value }) {
    commit('addElementVariantFormField', { sku, field, value });
  },
  setElementField({ commit }, { field, value }) {
    commit('setElementField', { field, value });
  },
  getElementAction({ state, commit }, elementId) {
    const cancelToken = refreshCancelToken(state, 'getElement');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    const params = {
      'fields[element]': 'edit',
    };
    return elementsApi.getArtistElement(elementId, params, axiosConfig)
      .then((response) => {
        // response.data.data.assetUrl = 'https://firefly.adobe.com/generate/images...';
        const data = response.data.data;
        if (data.variants.length) {
          data.variants = data.variants.map(v => ({ ...v, loading: false }));
          data.variants.sort((a, b) => b.createdAt - a.createdAt);
          data.variants[0].latest = true;
          // data.status = 'ingesting';
        }
        if (!data.thumbnails.jpgs) {
          data.thumbnails.jpgs = [];
        }
        console.log('================ ELEMENT STATUS: ', data.status);
        console.log('SETTT ELEMENT', state);
        commit('setElement', data);
        return response;
      });
  },
  addElementVariant({ state }, uploadUrl) {
    return elementsApi.addElementVariant(state.element.id, uploadUrl);
  },
  deleteElementVariant({ state, commit }, variantId) {
    const index = state.element.variants.findIndex(v => v.id === variantId);
    commit('setLoadingElementVariant', { index, status: true });
    elementsApi.deleteElementVariant(state.element.id, variantId)
      .then(() => {
        commit('removeElementVariant', index);
      })
      .catch(err => {
        console.error(err);
        commit('setLoadingElementVariant', { index, status: false });
      })
      .finally(() => {
        // commit('setLoadingElementVariant', { index, status: false });
      });
  },
  setDefaultElementVariant({ state, commit }, variantId) {
    const index = state.element.variants.findIndex(v => v.id === variantId);
    commit('setLoadingElementVariant', { index, status: true });
    elementsApi.setDefaultElementVariant(variantId)
      .then(() => {
        commit('setDefaultElementVariant', index);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoadingElementVariant', { index, status: false });
      });
  },
  updateElement({ commit }, { elementId, data }) {
    return elementsApi.updateArtistElement(elementId, data)
      .then((response) => {
        console.log(response);
        commit('setLoading', false);
        return response;
      });
  },
  replaceElementPreviews(state, { elementId, params }) {
    return elementsApi.replaceElementPreview(elementId, params);
  },
  // eslint-disable-next-line
  publishElement({ commit, state }, sku) {
    console.log('publishElements action', sku);
    commit('setLoading', true);
    return elementsApi.publishElement(sku)
      .then((response) => {
        console.log(response);
        const data = response.data.data;
        const element = { ...state.element };
        element.status = data.status;
        element.publishedAt = data.publishedAt;
        commit('setElement', element);
        return response;
        // update vuex with published elements
        // const elements = response.data.data;
        //
        // updateStateElements(state, elements);
        //
        // return response;
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  // eslint-disable-next-line
  unpublishElement({ commit, state }, sku) {
    console.log('publishElements action', sku);
    return elementsApi.unpublishElement(sku)
      .then((response) => {
        console.log(response);
        const data = response.data.data;
        const element = { ...state.element };
        element.status = data.status;
        commit('setElement', element);
        return response;
        // update vuex with published elements
        // const elements = response.data.data;
        //
        // updateStateElements(state, elements);
        //
        // return response;
      });
  },
  // publishCollection({ commit }, collectionId) {
  //   console.log('publishCollection action', collectionId);
  //   return collectionApi.publishCollection(collectionId)
  //     .then((response) => {
  //       console.log(response);
  //       const data = response.data.data;
  //       // const element = { ...state.element };
  //       // element.status = data.status;
  //       // element.publishedAt = data.publishedAt;
  //       commit('setCollection', data);
  //       return response;
  //     });
  // },
  // unpublishCollection({ commit }, collectionId) {
  //   console.log('publishElements action', collectionId);
  //   return elementsApi.unpublishCollection(collectionId)
  //     .then((response) => {
  //       console.log(response);
  //       const data = response.data.data;
  //       // const element = { ...state.element };
  //       // element.status = data.status;
  //       commit('setCollection', data);
  //       return response;
  //     });
  // },
  addElementPreview(state, { elementId, params }) {
    return elementsApi.addElementPreview(elementId, params)
      .then(response => {
        console.log(response);
        return response;
      });
  },
  // addElementPreviewMusic(state, { elementId, url }) {
  //   const params = { url };
  //   return elementsApi.addElementPreviewMusic(elementId, params)
  //     .then(response => {
  //       console.log(response);
  //       return response;
  //     });
  // },
  // TUTORIALS
  addElementTutorial(state, { elementId, url }) {
    return elementsApi.addElementTutorial(elementId, { url })
      .then(response => {
        console.log(response);
        return response;
      });
  },
  //
  listPriceTemplates({ commit }, params) {
    return templatesApi.listPriceTemplates(params)
      .then(({ data: { data } }) => {
        commit('setPriceTemplates', data);
      });
  },
  async listCollections({ commit }) {
    const collections = await collectionsApi.listCollections();
    commit('setCollections', collections);
  },
  // list all taxonomies
  listCategories({ commit }, params) {
    artistCategoriesApi.listArtistCategories(params)
      .then(({ data: { data } }) => {
        commit('setCategories', data);
      });
  },
  /*
  listGenres({ commit }, mediaType) {
    categoriesApi.listCategories(mediaType, {
      type: 'genre',
    })
      .then(({ data: { data } }) => {
        commit('setGenres', data);
      });
  },
  listStyles({ commit }, mediaType) {
    categoriesApi.listCategories(mediaType, {
      type: 'style',
    })
      .then(({ data: { data } }) => {
        commit('setStyles', data);
      });
  },
  listMoods({ commit }, mediaType) {
    categoriesApi.listCategories(mediaType, {
      type: 'mood',
    })
      .then(({ data: { data } }) => {
        commit('setMoods', data);
      });
  },
  listTypes({ commit }, mediaType) {
    categoriesApi.listCategories(mediaType, {
      type: 'type',
    })
      .then(({ data: { data } }) => {
        commit('setTypes', data);
      });
  },
  */
  listReleaseFiles({ commit }, params) {
    console.log('listReleasefiles', params);

    // if (Array.isArray(state.releaseFiles)) {
    //   return Promise.resolve(true);
    // }

    return releasesApi.listReleaseFiles(params)
      .then((response) => {
        console.log('list releases2', response.data.data);
        commit('setReleaseFiles', response.data.data);
        return response;
      });
    // this.allReleases = response.data.data;
  },
  listModelReleases({ commit }, params) {
    params = { ...params, type: 'model_release' };
    return releasesApi.listReleaseFiles(params)
      .then((response) => {
        commit('setModelReleases', response.data.data);
        return response;
      });
  },
  listPropertyReleases({ commit }, params) {
    params = { ...params, type: 'property_release' };
    return releasesApi.listReleaseFiles(params)
      .then((response) => {
        commit('setPropertyReleases', response.data.data);
        return response;
      });
  },
  async listInstruments({ commit }) {
    const instruments = await mediaTypesApi.get({ mediaType: 'music', field: 'instruments' });
    commit('setInstruments', instruments);
  },
  async listEditTypes({ commit }) {
    const editTypes = await mediaTypesApi.get({ mediaType: 'music', field: 'edit-types' });
    commit('setEditTypes', editTypes);
  },
  async listSoftwares({ commit }, mediaType) {
    const softwares = await mediaTypesApi.get({ mediaType, field: 'software-versions' });
    commit('setSoftwares', softwares);
  },
  regenerateElementPreviews({ commit }, { elementId }) {
    elementsApi.regenerateElementPreviews(elementId)
      .then((response) => {
        console.log(response);
        console.log(commit);
        // commit('setLoading', false);
        return response;
      });
  },
  // updateVideoPreview({ commit }, { url }) {
  //   console.log('UPLOAD', url, ext);
  //
  //   // elementsApi.uploadVideoPreivew(elementId, url);
  //   // commit('setVideoPreview', { ext, url });
  //
  //   // element.previews[ext] = url ? { url } : false;
  // },
  // uploadVideoPreview({ commit }, { elementId, ext, url }) {
  //   console.log('UPLOAD', url, ext);
  //
  //   elementsApi.uploadVideoPreivew(elementId, url);
  //   commit('setVideoPreview', { ext, url });
  //
  //   // element.previews[ext] = url ? { url } : false;
  // },
  // listMetadataTemplates({ commit }) {
  //   templatesApi.listMetadataTemplates()
  //     .then(({ data: { data } }) => {
  //       commit('setMetadataTemplates', data);
  //     });
  // },
  async getCountries({ commit }) {
    const countries = await appApi.getCountries();
    commit('setCountries', countries);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
